module.exports = __webpack_public_path__ + "img/OB1.8c610473.jpg";